import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FirstAccessScreenComponent } from './first-access-screen.component';
import { LoadingCircleModule } from 'src/app/shared/component/common/loading-circle/loading-circle.module';
import { TemplateErrorModule } from 'src/app/shared/component/common/template-error/template-error.module';
import { IdsModule } from 'src/app/ids.module';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    LoadingCircleModule,
    TemplateErrorModule,
    IdsModule
  ],
  declarations: [FirstAccessScreenComponent]
})
export class FirstAccessModule {}
